import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/feature/Logo';
import Footer from '@/components/feature/Footer';

interface LegalLayoutProps {
  eyebrow: string;
  title: string;
  updatedAt: string;
  intro: string;
  children: ReactNode;
}

export default function LegalLayout({
  eyebrow,
  title,
  updatedAt,
  intro,
  children,
}: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-background-100 flex flex-col">
      <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="px-4 md:px-8 lg:px-12 h-20 flex items-center justify-between">
          <Link to="/">
            <Logo />
          </Link>
          <Link
            to="/"
            className="hidden sm:flex items-center gap-2 px-4 py-2.5 rounded-md bg-foreground-950 hover:bg-foreground-800 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
            Retour au site
          </Link>
        </div>
      </header>

      <main className="flex-1 px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-3">
            {eyebrow}
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight mb-4">
            {title}
          </h1>
          <p className="text-sm text-foreground-500 mb-6">Dernière mise à jour : {updatedAt}</p>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-10">{intro}</p>

          <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-9 legal-content">
            {children}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 p-5 rounded-xl bg-primary-50 border border-primary-200">
            <p className="text-sm text-primary-900 text-center sm:text-left">
              Une question sur ces documents ? Écrivez-nous à <strong>contact@medicaclic.com</strong>.
            </p>
            <a
              href="mailto:contact@medicaclic.com"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
              Nous contacter
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}